<template>
    <section class="flex items-center px-4 md:px-content pt-4 md:py-20 relative h-[80vh] md:min-h-[80vh] will-change" :data-scroll-section="inner == 'false'">
        <!-- BLOCK ORIENTATION -> blockData.block_orientation -->

        <!-- img -->
        <div class="img-holder overflow-hidden absolute top-0 left-0 w-full h-full">
            <XyzTransition appear-visible duration="auto" class="custom-easing-1" xyz="fade big-25% duration-25">
                <img class="object-cover w-full h-full" v-show="blockData.image" :src="blockData.image.url" :alt="blockData.image.alt">
            </XyzTransition>
        </div>

        <template v-if="blockData.block_orientation === 'text-right'">

            <!-- text -->
            <div class="self-start md:self-center bg-navy-blue-01 text-white xl:ml-auto p-desk xl:px-20 relative w-full md:w-[50vw] max-w-[588px] z-10" data-scroll data-scroll-speed="1.5"  >
                <div class="tracking-desk text-sm mb-4 leading-5 uppercase text-navy-blue-03" v-show="blockData.kicker">{{ blockData.kicker }}</div>
                <h2 class="text-[28px] xl:text-heading mb-8 text-white" v-show="blockData.title">{{ blockData.title }}</h2>
                <div class="" v-show="blockData.text" v-html="blockData.text"></div>
                <a class="btn btn-clean" v-show="blockData.cta" :href="blockData.cta.url" >{{ blockData.cta.title }}
                    <svg class="ml-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 12L21 12" stroke="#405664" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round" />
                        <path d="M18 8L22 12L18 16" stroke="#405664" stroke-width="1.2" stroke-linecap="square" />
                    </svg>
                </a>
            </div>

        </template>

        <template v-else>
            <!-- text -->
            <div class="self-start md:self-center bg-navy-blue-01 text-white relative p-desk xl:px-20  w-full md:w-[50vw] max-w-[588px] z-10" data-scroll data-scroll-speed="1.5"  >
                <div class="tracking-desk text-sm mb-4 leading-5 uppercase text-navy-blue-03" v-show="blockData.kicker">{{ blockData.kicker }}</div>
                <h2 class="text-[28px] xl:text-heading mb-8 text-white" v-show="blockData.title">{{ blockData.title }}</h2>
                <div class="" v-show="blockData.text" v-html="blockData.text"></div>
                <a class="btn btn-clean" v-show="blockData.cta" :href="blockData.cta.url" >{{ blockData.cta.title }}
                    <svg class="ml-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 12L21 12" stroke="white" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round"/>
                        <path d="M18 8L22 12L18 16" stroke="white" stroke-width="1.2" stroke-linecap="square"/>
                    </svg>
                </a>
            </div>

        </template>

    </section>
</template>


<script>
    export default {
        name: 'ImageSideCard',
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {

        },
    }
</script>

<style>
  .custom-easing-1 {
    --xyz-ease: cubic-bezier(0,.83,0,1);
  }
</style>
